<template>
  <section class="section is-medium">
    <div class="container has-text-centered condensed">
      <h2 v-html="$t('profile.ABStatus.' + taxonCategroyName + 'aboutHeader', { sppName: state?.sppName })"></h2>
      <div v-if="!toShowOverviewTab" class="profile richtext container has-text-centered condensed bold" v-html="sppContent?.AppDescription"></div>
    </div>
    <div class="container has-text-centered">
      <template v-if="hasAnyStatusTabSections">
        <div v-if="state?.isSpecies" class="spp richtext bold condensed"
          v-html="$t('profile.ABStatus.species.model.' + getModel(), { sppName: state?.sppName, regionType: (state?.isForestModel == dataModel.full ? 'forested': '') + (state?.isPrairieModel === dataModel.full ? ' prairie': '')})">
        </div>
        <div v-else class="habitat bold auto condensed"
            v-html="$t('profile.ABStatus.habitat.model', { sppName: state?.sppName})">
        </div>
        <h4 class="condensed">{{ $t("profile.ABStatus.sectionIntroLead") }} </h4>
        <p>
          <a :href="profilePageUrl + '#occurrenceSection'" class="button is-primary" v-if="!toShowOverviewTab">
            {{ $t("profile.aboutSpp.occurrenceLinkText") }}
          </a>
          <template v-for="(section, index) in sections" :key="'ABStatusSection' + index">
            <a :href="profilePageUrl + '#' + section[0]" class="button is-primary" v-if="state[section[1]]">
              {{ $t("profile.ABStatus." + section[0] + ".sectionHeader") }}
            </a>
          </template>
          <a :href="profilePageUrl + '#natureLynxSection'" class="button is-primary" v-if="!toShowOverviewTab && state.sightings?.length > 0">
            {{ $t("profile.aboutSpp.natureLynx.header") }}
          </a>
        </p>
      </template>
      <template v-else>
        <p  class="has-text-centered auto" v-if="state.hasMap"><span v-html='$t("profile.ABStatus." + taxonCategroyName + "withoutContent", { sppName: state?.sppName } )'> </span></p>
        <p  class="has-text-centered auto" v-else><span class="has-text-centered auto" v-html='$t("profile.ABStatus." + taxonCategroyName + "withoutContentMap", { sppName: state?.sppName } )'> </span></p>
      </template>
    </div>
  </section>
</template>
<script>

import { DATA_MODEL as dataModel, statusTabSections as sections } from '@/config/profile-config';
import { useApp } from '@/composables/state/profileState';

export default {
  name: 'abStatus-Intro',
  setup (props) {
    const { profilePageUrl, state, sppContent, taxonCategroyName, toShowOverviewTab, hasAnyStatusTabSections } = useApp();
    const getModel = () => {
      let model = 'basic';
      switch (state?.summaryType) {
        case 'Full':
          model = 'full';
          break;
        case 'Forested':
          model = 'forest';
          break;
        case 'Prairie':
          model = 'prairie';
          break;
        default:
          model = 'basic';
      }
      return model;
    };
    return {
      state,
      sppContent,
      profilePageUrl,
      dataModel,
      sections,
      toShowOverviewTab,
      getModel,
      hasAnyStatusTabSections,
      taxonCategroyName
    }
  }
}
</script>

<style scoped>
@import "./status-intro.css";
</style>
